import { useState, useEffect, useCallback } from "react"
import {
  supabase,
  getOnboardingState,
  markOnboardingTipSeen,
  getHasDailyWellness,
  type OnboardingStateRow,
  type TipKey,
} from "@/lib/supabase"

export type { TipKey, OnboardingStateRow }

export function useOnboarding() {
  const [state, setState] = useState<OnboardingStateRow | null>(null)
  const [loading, setLoading] = useState(true)
  const [isJ3, setIsJ3] = useState(false)
  const [hasHooper, setHasHooper] = useState(false)

  useEffect(() => {
    const init = async () => {
      try {
        const [onboarding, { data: userData }, hasWellness] = await Promise.all([
          getOnboardingState(),
          supabase.auth.getUser(),
          getHasDailyWellness(),
        ])
        setState(onboarding)
        setHasHooper(hasWellness)

        const createdAt = userData.user?.created_at
        if (createdAt) {
          setIsJ3(Date.now() - new Date(createdAt).getTime() >= 3 * 24 * 60 * 60 * 1000)
        }
      } catch (e) {
        console.error("[useOnboarding] init error:", e)
      } finally {
        setLoading(false)
      }
    }
    init()
  }, [])

  const markTipSeen = useCallback(async (key: TipKey): Promise<void> => {
    setState(prev => prev ? { ...prev, [key]: true } : null)
    try {
      await markOnboardingTipSeen(key)
    } catch (e) {
      console.error("[useOnboarding] markTipSeen error:", e)
      setState(prev => prev ? { ...prev, [key]: false } : null)
    }
  }, [])

  return { state, loading, isJ3, hasHooper, markTipSeen }
}
